<div
  class="group-node group-node--all"
  [class.group-node--selected]="selectedGroupId() === null"
  [class.group-node--drop-target]="rootDropActive()"
  (click)="select(null)"
  (dragover)="onDragOver($event, null)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event, null)"
>
  <span class="group-node-chevron group-node-chevron--spacer"></span>
  <i eIcon icon="chart-simple" class="group-node-icon"></i>
  <span class="group-node-name">{{ text().allCharts }}</span>
</div>

@for (node of nodes(); track node.group.id) {
  <div
    class="group-node"
    [class.group-node--selected]="selectedGroupId() === node.group.id"
    [class.group-node--drop-target]="dropTargetId() === node.group.id && dropPosition() === 'inside'"
    [class.group-node--insert-before]="dropTargetId() === node.group.id && dropPosition() === 'before'"
    [class.group-node--insert-after]="dropTargetId() === node.group.id && dropPosition() === 'after'"
    [class.group-node--dragging]="draggedGroupId() === node.group.id"
    [class.group-node--flash]="flashGroupId() === node.group.id"
    [style.paddingLeft.px]="12 + node.level * 16"
    draggable="true"
    (click)="select(node.group.id ?? null)"
    (dragstart)="onDragStart($event, node.group)"
    (dragend)="onDragEnd()"
    (dragover)="onDragOver($event, node.group.id ?? null)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event, node.group.id ?? null)"
  >
    @if (node.hasChildren) {
      <button
        type="button"
        class="group-node-chevron"
        (click)="toggleCollapse(node.group.id, $event)"
      >
        <i eIcon [icon]="isCollapsed(node.group.id) ? 'chevron-right' : 'chevron-down'"></i>
      </button>
    } @else {
      <span class="group-node-chevron group-node-chevron--spacer"></span>
    }
    @if (flashGroupId() === node.group.id) {
      <i eIcon icon="check" class="group-node-icon group-node-flash-check"></i>
    } @else {
      <i eIcon [icon]="node.group.icon || 'folder-tree'" class="group-node-icon"></i>
    }
    <span class="group-node-name" [title]="node.group.name">{{ node.group.name }}</span>
    <span class="group-node-count">{{ node.group.chartCount }}</span>
    <span class="group-node-actions">
      <button
        eBtn
        dense
        size="sm"
        icon="pen"
        iconColor="primary-75"
        [tooltip]="text().edit"
        (click)="$event.stopPropagation(); editRequested.emit(node.group)"
      ></button>
      <button
        eBtn
        dense
        size="sm"
        icon="trash"
        iconColor="danger"
        [tooltip]="text().delete"
        (click)="$event.stopPropagation(); deleteRequested.emit(node.group)"
      ></button>
    </span>
  </div>
}
